import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import makeAnimated from 'react-select/animated'

import MyPropTypes from '@global/propTypes'
import Label from '@components/label'
import { useTheme } from 'styled-components'
import { SelectStyles } from './styles'

const animatedComponents = makeAnimated()

const SelectInput = props => {
  const {
    options,
    placeholder,
    color,
    value,
    onChange,
    noOptionsMessage,
    disabled,
    size,
    isMulti,
    asyncSelect,
    loadOptions,
    label,
    required,
    loadingMessage,
    loading
  } = props

  const theme = useTheme()

  const renderSelect = () => (
    <Select
      options={options}
      placeholder={placeholder}
      value={value}
      color={color}
      onChange={onChange}
      components={animatedComponents}
      styles={SelectStyles}
      isMulti={isMulti}
      isSearchable
      clereable
      isLoading={loading}
      loadingMessage={loadingMessage}
      isDisabled={disabled}
      noOptionsMessage={noOptionsMessage}
      size={size}
      theme={theme}
    />
  )

  const renderAsyncSelect = () => (
    <AsyncSelect
      value={value}
      placeholder={placeholder}
      loadOptions={loadOptions}
      onChange={onChange}
      color={color}
      isMulti={isMulti}
      styles={SelectStyles}
      loadingMessage={loadingMessage}
      noOptionsMessage={noOptionsMessage}
      theme={theme}
    />
  )

  return (
    <>
      {label && (
      <Label text={label} disabled={disabled} required={required} />
      )}
      {asyncSelect ? renderAsyncSelect() : renderSelect()}
    </>
  )
}

SelectInput.propTypes = {
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  color: MyPropTypes.color,
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  noOptionsMessage: PropTypes.func,
  isMulti: PropTypes.bool,
  size: PropTypes.oneOf([
    'small',
    'medium',
    'large'
  ]),
  asyncSelect: PropTypes.bool,
  loadOptions: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  loadingMessage: PropTypes.func,
  loading: PropTypes.bool
}

export default SelectInput
